import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const UpdatesTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
export const Header = styled.div`
  ${typography.up1.regularSerif}
`

export const Subheader = styled.div`
  ${typography.baseline.regularSans}
`

export const HeaderAndButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 85%;
`

export const DialogAnchor = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
`

export const UpdatesTable = styled.div`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 16px;
`

export const DividerContainer = styled.div`
  padding: 0 16px;
`
